import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCalendar, faCheckCircle, faHome, faIdCard, faLayerGroup, faListAlt, faListCheck, faListDots, faListOl, faQrcode, faUser, faUsers, faUserTie } from '@fortawesome/free-solid-svg-icons';
import './RiskMatics.css';

function RiskMaticsHome() {
  const applicationAreas = [
    { title: 'Life Insurance', category: 'Insurance', icon: 'fa-heartbeat' },
    { title: 'Health Insurance', category: 'Insurance', icon: 'fa-medkit' },
    { title: 'Pension Plans', category: 'Finance', icon: 'fa-piggy-bank' },
    { title: 'General Insurance', category: 'Insurance', icon: 'fa-home' },
    { title: 'Risk Management', category: 'Finance', icon: 'fa-shield-alt' },
    { title: 'Reinsurance', category: 'Insurance', icon: 'fa-sync-alt' },
    { title: 'Annuities', category: 'Finance', icon: 'fa-dollar-sign' },
    { title: 'Investment Strategy', category: 'Finance', icon: 'fa-chart-line' },
    { title: 'Product Development', category: 'Finance', icon: 'fa-box' },
    { title: 'Underwriting', category: 'Insurance', icon: 'fa-file-alt' },
    { title: 'Reserve Estimation', category: 'Insurance', icon: 'fa-calculator' },
    { title: 'Catastrophe Modeling', category: 'Insurance', icon: 'fa-cloud-showers-heavy' },
    { title: 'Social Security Planning', category: 'Finance', icon: 'fa-users' },
    { title: 'Employee Benefits Design', category: 'HR', icon: 'fa-briefcase' },
    { title: 'Enterprise Risk Management (ERM)', category: 'Finance', icon: 'fa-building' },
    { title: 'Financial Reporting', category: 'Finance', icon: 'fa-file-invoice' },
    { title: 'Mergers & Acquisitions', category: 'Finance', icon: 'fa-handshake' },
    { title: 'Credit Risk Analysis', category: 'Finance', icon: 'fa-credit-card' },
    { title: 'Market Risk Analysis', category: 'Finance', icon: 'fa-chart-bar' },
    { title: 'Longevity Risk Management', category: 'Finance', icon: 'fa-calendar' },
    { title: 'Claims Forecasting', category: 'Insurance', icon: 'fa-chart-pie' },
    { title: 'Profitability Analysis', category: 'Finance', icon: 'fa-dollar-sign' },
    { title: 'Capital Management', category: 'Finance', icon: 'fa-piggy-bank' },
    { title: 'Healthcare Cost Management', category: 'Healthcare', icon: 'fa-stethoscope' },
    { title: 'Climate Risk Modeling', category: 'Insurance', icon: 'fa-sun' }
];

  return (
    <MainLayout>
      <div className="min-h-screen py-8 bg-gradient-to-r from-purple-500 via-purple-500 to-green-500">
        <h2 className='text-3xl font-bold text-white text-center mb-2'>RiskMatics@Think5Whys</h2>
        <div className="bg-white text-white p-4 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6 mt-4">
          <Link to={"/riskmatics-myservices"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faHome} className="text-2xl sm:text-2xl mr-3" />
            <span>My Services</span>
          </Link>

          <Link to={"/riskmatics-myconsultants"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faBolt} className="text-2xl sm:text-2xl mr-3" />
            <span>My Consultants</span>
          </Link>

          <Link to={"/riskmatics-need-consultant"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faCalendar} className="text-2xl sm:text-2xl mr-3" />
            <span>I Need Consultant</span>
          </Link>

          <Link to={"/riskmatics-myclients"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faCheckCircle} className="text-2xl sm:text-2xl mr-3" />
            <span>My Clients</span>
          </Link>

          <Link to={"/riskmatics-enroll-iamavailable"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faUserTie} className="text-2xl sm:text-2xl mr-3" />
            <span>I am Available</span>
          </Link>

          <Link to={"/riskmatics-enroll-actuary"} className="flex items-center text-sm sm:text-md text-gray-700 hover:text-gray-900 transition duration-300">
            <FontAwesomeIcon icon={faLayerGroup} className="text-2xl sm:text-2xl mr-3" />
            <span>Enroll as Actuary</span>
          </Link>

        </div>

        <div className="grid sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 ml-8 mr-8 mt-8">
          {applicationAreas.map((service, index) => (
            <Link to={`/riskmatics-applicationAreas-list/${service.category}`} key={index}>
              <div
                className="bg-gray-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-300 transition duration-300"
              >
                <i className={`fas ${service.icon} text-2xl text-blue-500 mb-2`}></i>
                <h2 className="text-sm font-semibold break-words whitespace-normal">
                  {service.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default RiskMaticsHome;



